import { ref, computed } from "vue";

/**
 * Shared chat-panel layout state.
 *
 * The co-scientist chat panel lives inside MethodPage, but other globally
 * mounted UI (e.g. the toast viewport in App.vue) sits *above* MethodPage in
 * the component tree and so can't reach it via provide/inject. This module is
 * a small reactive channel for that cross-tree state.
 */

/** Whether the co-scientist chat panel is currently open. */
export const chatPanelOpen = ref(false);

/** Current width of the chat panel in px (only meaningful when open). */
export const chatPanelWidthPx = ref(0);

/** Width of the resize handle to the left of the chat panel. */
const CHAT_RESIZE_HANDLE_PX = 4;

/**
 * Right inset (px) that fixed bottom-right UI should clear so it doesn't
 * overlap the chat panel. 0 when the chat is closed.
 */
export const chatRightInsetPx = computed(() =>
  chatPanelOpen.value ? chatPanelWidthPx.value + CHAT_RESIZE_HANDLE_PX : 0
);
